import React, { useEffect, useRef, useState } from "react";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message } from "antd";
import swal from "sweetalert";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import {
  hasNumeric,
  hasSpecialCharacter,
  isNameValid,
  isValidAddress,
  isEmailValid,
  isPinValid,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function ESIForm({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setESIPreviewData,
  setActivePanel,
  application,
  setIsFieldTouch,
}) {
  let _aadhar = aadharDetails || {};
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;
  const IS_DISABLE_PHOTO =
    filledForm?.formStatusByHR === false
      ? !application?.candidatePhotoStatus
        ? true
        : false
      : false;
  const { house, street, state, loc, dist } =
    _aadhar?.aadharVerificationDetails?.data?.address || {};

  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, state, loc, dist].filter(Boolean).join(", ") ||
    "";

  const NAME = _aadhar?.aadharVerificationDetails?.data?.full_name || "";

  const DOB = application?.responses?.find(
    (item) => item?.label === "Date of Birth"
  )?.value;

  const AADHAR_GENDER = _aadhar?.aadharVerificationDetails?.data?.gender || "";

  const FORM_GENDER =
    application?.responses?.find((item) => item?.label === "Gender")?.value ||
    "";

  const GENDER = AADHAR_GENDER
    ? AADHAR_GENDER === "M"
      ? "male"
      : AADHAR_GENDER === "F"
      ? "female"
      : ""
    : FORM_GENDER
    ? FORM_GENDER?.toLowerCase()
    : "";

  const api = useAxios();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name:
      filledForm?.documentDetails?.name ||
      NAME ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    father_name:
      filledForm?.documentDetails?.father_name ||
      metaData?.father_name?.trim() ||
      _aadhar?.aadharVerificationDetails?.data?.care_of
        ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
        .trim() ||
      "",
    dob:
      filledForm?.documentDetails?.dob ||
      _aadhar?.aadharVerificationDetails?.data?.dob ||
      DOB ||
      "",
    marital_status:
      filledForm?.documentDetails?.marital_status ||
      (metaData?.marital_status?.toLowerCase() === "single"
        ? "unmarried"
        : metaData?.marital_status?.toLowerCase() === "widower"
        ? "widow"
        : metaData?.marital_status?.toLowerCase() || ""),
    sex:
      filledForm?.documentDetails?.sex ||
      GENDER ||
      metaData?.gender?.toLowerCase() ||
      "",
    present_address:
      filledForm?.documentDetails?.present_address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    present_pin:
      filledForm?.documentDetails?.present_pin ||
      _aadhar?.aadharVerificationDetails?.data?.zip ||
      metaData?.pin_code ||
      "",
    present_email:
      filledForm?.documentDetails?.present_email || metaData?.email || "",
    permanent_address:
      filledForm?.documentDetails?.permanent_address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    permanent_pin:
      filledForm?.documentDetails?.permanent_pin ||
      _aadhar?.aadharVerificationDetails?.data?.zip ||
      metaData?.pin_code ||
      "",
    permanent_email:
      filledForm?.documentDetails?.permanent_email || metaData?.email || "",
    name_of_nominee: filledForm?.documentDetails?.name_of_nominee || "",
    relationship_with_insured_person:
      filledForm?.documentDetails?.relationship_with_insured_person || "",
    address_of_the_nominee:
      filledForm?.documentDetails?.address_of_the_nominee || "",
    relation: filledForm?.documentDetails?.relation || "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [prevInsauranceNumber, setPrevInsauranceNumber] = useState(
    filledForm?.documentDetails?.prevInsauranceNumber || ""
  );
  const [insauranceNumber, setInsauranceNumber] = useState(
    filledForm?.documentDetails?.insauranceNumber || ""
  );
  const [dispensary, setDispensary] = useState(
    filledForm?.documentDetails?.dispensary || ""
  );

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (formData[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (flag) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    const data = {
      companyDocumentId: form?._id,
      candidateId: id,
      documentDetails: {
        ...formData,
        ...(dispensary !== "" ? { dispensary } : {}),
        ...(insauranceNumber !== "" ? { insauranceNumber } : {}),
        ...(prevInsauranceNumber !== "" ? { prevInsauranceNumber } : {}),
      },
      formStatus: true,
    };

    try {
      setLoading(true);
      await api.post(`/companyDocuments/DocumentMaping`, data, {
        tokenType: "candidate",
      });
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!", 2);
      setActivePanel(null);
      setLoading(false);
      setIsFieldTouch(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setESIPreviewData({
      ...formData,
      ...(dispensary !== "" ? { dispensary } : {}),
      ...(insauranceNumber !== "" ? { insauranceNumber } : {}),
      ...(prevInsauranceNumber !== "" ? { prevInsauranceNumber } : {}),
    });
    let e = {};

    // if (formData?.name.trim()) {
    //   e.name = isNameValid(formData.name);
    // }
    // if (formData?.father_name.trim()) {
    //   e.father_name = isNameValid(formData.father_name);
    // }
    if (formData?.name_of_nominee.trim()) {
      e.name_of_nominee = isNameValid(formData.name_of_nominee);
    }
    // if (new Date(formData.dob) > new Date()) {
    //   e.dob = "Future date is not allowed.";
    // } else {
    //   e.dob = "";
    // }

    // if (formData?.present_address.trim()) {
    //   e.present_address = isValidAddress(formData?.present_address);
    // }

    // if (formData?.permanent_address.trim()) {
    //   e.permanent_address = isValidAddress(formData?.permanent_address);
    // }

    if (formData?.address_of_the_nominee.trim()) {
      e.address_of_the_nominee = isValidAddress(
        formData?.address_of_the_nominee
      );
    }

    // if (formData?.present_email.trim()) {
    //   e.present_email = isEmailValid(formData?.present_email);
    // }

    // if (formData?.permanent_email.trim()) {
    //   e.permanent_email = isEmailValid(formData?.permanent_email);
    // }

    // if (formData?.present_pin.trim()) {
    //   e.present_pin = isPinValid(formData?.present_pin);
    // }

    // if (formData?.permanent_pin.trim()) {
    //   e.permanent_pin = isPinValid(formData?.permanent_pin);
    // }

    if (
      formData.relationship_with_insured_person &&
      formData.relationship_with_insured_person?.trim().length < 3
    ) {
      e.relationship_with_insured_person =
        "Relationship must be greater than 3 char";
    } else {
      if (
        hasNumeric(formData.relationship_with_insured_person?.trim()) ||
        hasSpecialCharacter(formData.relationship_with_insured_person?.trim())
      ) {
        e.relationship_with_insured_person =
          "No numeric or special character allowed.";
      } else {
        e.relationship_with_insured_person = "";
      }
    }

    setError(e);
  }, [formData, filledForm]);
  return (
    <Card>
      {loading ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div className="row">
          <div className="col-12">
            <p style={{ color: "red", fontSize: "14px" }}>
              <strong>Note:</strong> All fields marked with an asterisk (
              <span style={{ color: "red" }}>*</span>) are mandatory.
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name (in block capital)
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="name"
                  onChange={handleChange}
                  style={{
                    ...(error?.name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-6 form-builder-element mb-3">
                <div className="d-flex justify-content-between">
                  <label htmlFor="">
                    Father's / Husband's Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="form-group form-builder-element">
                    <div className="row">
                      <div className="custom-control custom-radio mx-3">
                        <input
                          id="esi_relation_father"
                          disabled={filledForm?.formStatusByHR}
                          name="relation"
                          type="checkbox"
                          className="custom-control-input form-view"
                          onChange={handleChange}
                          value="father"
                          checked={formData?.relation === "father"}
                        />
                        <label
                          htmlFor="esi_relation_father"
                          className="custom-control-label"
                        >
                          Father
                        </label>
                      </div>
                      <div className="custom-control custom-radio mx-3">
                        <input
                          disabled={filledForm?.formStatusByHR}
                          id="esi_relation_husband"
                          name="relation"
                          type="checkbox"
                          className="custom-control-input form-view"
                          onChange={handleChange}
                          value="husband"
                          checked={formData?.relation === "husband"}
                        />
                        <label
                          htmlFor="esi_relation_husband"
                          className="custom-control-label"
                        >
                          Husband
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="father_name"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.father_name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.father_name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.father_name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.father_name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Date of Birth
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="date"
                  disabled={filledForm?.formStatusByHR || true}
                  name="dob"
                  max={formatDate(new Date())}
                  onChange={handleChange}
                  style={{
                    ...(error?.dob ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.dob}
                />
                {error?.dob && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.dob}</p>
                )}
              </div>
              <div className="form-group mb-3 col-md-6 form-builder-element">
                <label htmlFor="">
                  Marital Status
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="esi_married"
                      name="marital_status"
                      disabled={filledForm?.formStatusByHR}
                      type="radio"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="married"
                      checked={formData?.marital_status === "married"}
                    />
                    <label
                      htmlFor="esi_married"
                      className="custom-control-label"
                    >
                      Married
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="esi_unmarried"
                      name="marital_status"
                      type="radio"
                      disabled={filledForm?.formStatusByHR}
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      checked={formData?.marital_status === "unmarried"}
                      value="unmarried"
                    />
                    <label
                      htmlFor="esi_unmarried"
                      className="custom-control-label"
                    >
                      Unmarried
                    </label>
                  </div>

                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="esi_widow"
                      name="marital_status"
                      type="radio"
                      disabled={filledForm?.formStatusByHR}
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      checked={formData?.marital_status === "widow"}
                      value="widow"
                    />
                    <label htmlFor="esi_widow" className="custom-control-label">
                      Widow
                    </label>
                  </div>
                    <div className="custom-control custom-radio mx-2">
                    <input
                      id="esi_separated"
                      name="marital_status"
                      type="radio"
                      disabled={filledForm?.formStatusByHR}
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      checked={formData?.marital_status === "separated"}
                      value="separated"
                    />
                    <label htmlFor="esi_separated" className="custom-control-label">
                      Separated
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Sex
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="esi_male"
                      disabled={filledForm?.formStatusByHR}
                      name="sex"
                      type="radio"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="male"
                      checked={formData?.sex === "male"}
                    />
                    <label htmlFor="esi_male" className="custom-control-label">
                      Male
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="esi_female"
                      name="sex"
                      type="radio"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="female"
                      checked={formData?.sex === "female"}
                    />
                    <label
                      htmlFor="esi_female"
                      className="custom-control-label"
                    >
                      Female
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-12 form-builder-element mb-3">
                <Card title="Present Address">
                  <div className="row">
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Address
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        name="present_address"
                        disabled={filledForm?.formStatusByHR || true}
                        placeholder=""
                        onChange={handleChange}
                        style={{
                          ...(error?.present_address
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.present_address}
                      />
                      {error?.present_address && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.present_address}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Pin
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="number"
                        placeholder=""
                        disabled={filledForm?.formStatusByHR || true}
                        name="present_pin"
                        onChange={handleChange}
                        min={0}
                        style={{
                          ...(error?.present_pin
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.present_pin}
                      />
                      {error?.present_pin && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.present_pin}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Email Address
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR || true}
                        placeholder=""
                        name="present_email"
                        onChange={handleChange}
                        style={{
                          ...(error?.present_email
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.present_email}
                      />
                      {error?.present_email && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.present_email}
                        </p>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-12 form-builder-element mb-3">
                <Card title="Permanent Address">
                  <div className="row">
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Address
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR || true}
                        placeholder=""
                        name="permanent_address"
                        onChange={handleChange}
                        style={{
                          ...(error?.permanent_address
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.permanent_address}
                      />
                      {error?.permanent_address && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.permanent_address}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Pin
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="number"
                        placeholder=""
                        disabled={filledForm?.formStatusByHR || true}
                        name="permanent_pin"
                        min={0}
                        onChange={handleChange}
                        style={{
                          ...(error?.permanent_pin
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.permanent_pin}
                      />
                      {error?.permanent_pin && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.permanent_pin}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Email Address
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        placeholder=""
                        disabled={filledForm?.formStatusByHR || true}
                        name="permanent_email"
                        onChange={handleChange}
                        style={{
                          ...(error?.permanent_email
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={formData?.permanent_email}
                      />
                      {error?.permanent_email && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {error?.permanent_email}
                        </p>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name of The Nominee
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="name_of_nominee"
                  onChange={handleChange}
                  style={{
                    ...(error?.name_of_nominee
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.name_of_nominee.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.name_of_nominee && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name_of_nominee}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Relationship With Insured Person*
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="relationship_with_insured_person"
                  onChange={handleChange}
                  value={formData?.relationship_with_insured_person}
                />
                {error?.relationship_with_insured_person && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.relationship_with_insured_person}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Address of The Nominee
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="address_of_the_nominee"
                  onChange={handleChange}
                  style={{
                    ...(error?.address_of_the_nominee
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.address_of_the_nominee}
                />
                {error?.address_of_the_nominee && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.address_of_the_nominee}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Previous Insurance Number</label>
                <input
                  className="form-control form-view"
                  type="number"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="previous_ins_no"
                  onChange={(e) => setPrevInsauranceNumber(e.target.value)}
                  style={{
                    ...(error?.previous_ins_no
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={prevInsauranceNumber}
                />
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Insurance Number</label>
                <input
                  className="form-control form-view"
                  type="number"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="ins_no"
                  onChange={(e) => setInsauranceNumber(e.target.value)}
                  style={{
                    ...(error?.ins_no ? { border: "1px solid red" } : {}),
                  }}
                  value={insauranceNumber}
                />
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Dispensary</label>
                <input
                  className="form-control form-view"
                  type="number"
                  disabled={filledForm?.formStatusByHR}
                  placeholder=""
                  name="dispensary"
                  onChange={(e) => setDispensary(e.target.value)}
                  style={{
                    ...(error?.dispensary ? { border: "1px solid red" } : {}),
                  }}
                  value={dispensary}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <button
                  className={`btn ${
                    validateInput() ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE ||
                    IS_DISABLE_PHOTO
                      ? "btn-secondary"
                      : "btn-primary"
                  }`}
                  onClick={handleSubmit}
                  disabled={
                    validateInput() ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE ||
                    IS_DISABLE_PHOTO
                  }
                >
                  <span className="pr-2">
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </span>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default ESIForm;
